angular.module('eStories.billing.model', [
    /*eStories Account Module*/

]).service('BillingModel', ['WS', function (WS) {
    this.isPlanPurchase = true;

    this.getPaymentError = (responseText) => {
        var errorMessage;
        switch (responseText) {
            case 'INTERNAL_ERROR':
            case 'NO_USER_OR_PAYMENT_METHOD_TO_STORE':
                errorMessage = 'Please enter a payment method to continue';
                break;
            case 'CREDIT_CARD_EXPIRED':
                errorMessage = 'This card has an expiration date in the past.  Please update to continue!';
                break;
            case 'TRANSACTION_FAILED':
                errorMessage = 'Oh no! An error has occurred, please try again! If the problem continues, please contact us at support@estories.com';
                break;
            case 'CANNOT_CREATE_PAYMENT_METHOD':
            case 'INVALID_PAYMENT_METHOD':
            case 'NO_PAYMENT_METHOD_TOKEN_RETURNED':
            case 'NO_SESSION':
            case 'ACCESS_DENIED':
            case 'INVALID_PAYMENT_METHOD_NONCE':
                errorMessage = 'Sorry, an error has occurred. Please try again! If the problem continues, please contact us at support@estories.com';
                break;
        }
        return errorMessage;

    };

    this.getPurchaseError = (responseText) => {
        var errorMessage;
        switch (responseText) {
            case 'OFFER_PRICING_NOT_FOUND':
            case 'OFFER_NOT_FOUND':
                errorMessage = 'The server ran into an error and could not move forward.  If the problem continues, please contact us at support@estories.com';
                break;
            case 'USER_NOT_FOUND':
                errorMessage = 'Sorry, something went wrong - user was not found. If this issue continues, please contact us at support@estories.com';
                break;
            case 'INVALID_USER_ID':
                errorMessage = 'Sorry, something went wrong - this user ID was not found. If this issue continues, please contact us at support@estories.com';
                break;
            case 'INVALID_PLAN_ID':
            case 'INVALID_PLAN_FAMILY':
            case 'PLAN_NOT_FOUND':
            case 'CREDIT_CARD_IS_SUBSCRIBED_FOR_TRIAL':
                errorMessage = 'Sorry, something went wrong. If this issue continues, please contact us at support@estories.com';
                break;
            case 'CANT_OVERRIDE_ONE_PLAN_WITH_ANOTHER':
                errorMessage = 'Sorry, something went wrong - plan cannot be changed. If this issue continues, please contact us at support@estories.com';
                break;
            case' DECLINED_VALIDATION_AUTH':
                errorMessage = 'Uh oh, payment validation did not go through.  Please re-enter your credit card or select a different payment method';
                break;
            case 'INTERNAL_ERROR':
            case 'NO_SESSION':
            case 'ACCESS_DENIED':
                errorMessage = 'Sorry, an error has occurred purchasing this title. Please try again! If the problem continues, please contact us at support@estories.com';
                break;
        }
        return errorMessage;
    };

    this.generateClientToken = () => {
        return WS.callServer('billing/generateClientToken', {});
    };
    this.purchaseTrial = (conversionPlanPricingId, trialPlanPricingId, utmObj) => {
        var request = {
            trialPlanPricingId: trialPlanPricingId,
            conversionPlanPricingId: conversionPlanPricingId,
        };
        request = Object.assign({}, request, utmObj);

        return WS.callServer('billing/purchaseTrial', request);
    };
    this.purchasePlan = (planPricingId, couponCode, utmObj) => {
        var request = {
            planPricingId: planPricingId,
            couponCode: couponCode ? couponCode : null,
        };
        request = Object.assign({}, request, utmObj);

        return WS.callServer('billing/purchasePlan', request);
    };

    this.purchasePromo = (conversionPlanPricingId, promoCode, utmObj) => {
        var request = {
            planPricingId: conversionPlanPricingId,
            promoCode: promoCode,

        };
        request = Object.assign({}, request, utmObj);
        return WS.callServer('billing/purchasePlan', request);
    };

    this.purchaseBooster = (planPricingId, promoCode) => {
        var request = {planPricingId: planPricingId, promoCode: promoCode};
        return WS.callServer('billing/purchaseBooster', request);
    };

    this.updatePlanImmediately = (subscriptionId, newPlanId, promoCode) => {
        var request = {
            subscriptionId: subscriptionId,
            newPlanId: newPlanId,
            promoCode: promoCode,
        };
        return WS.callServer('subscription/updatePlanImmediately', request);
    };

    this.updateConversionPlan = (subscriptionId, newPlanId, reasonDescription) => {
        var request = {
            subscriptionId: subscriptionId,
            newPlanId: newPlanId,
            reasonDescription: reasonDescription
        };
        return WS.callServer('subscription/updateConversionPlan', request);
    };

    this.purchaseGift = (planPricingId, from, recipientName, recipientEmail, message, sendDate) => {
        var request = {
            planPricingId: planPricingId,
            recipientEmail: recipientEmail,
            recipientName: recipientName,
            message: message,
            from: from,
            futureSendDate: sendDate

        };
        return WS.callServer('billing/purchaseGift', request);
    };

    this.getAvailablePlanListByFamilyList = (planFamilyList) => {
        var request = {planFamilyList: planFamilyList};
        return WS.callServer('billing/getAvailablePlanListByFamilyList', request);
    };

    this.purchaseAudiobook = (audiobookId, purchaseType) => {
        var request = {audiobookId: audiobookId, purchaseType: purchaseType};
        return WS.callServer('billing/purchaseAudiobook', request);
    };

    this.savePaymentDetails = (paymentMethod, paymentMethodNonce) => {
        var request = {
            paymentMethod: paymentMethod,
            paymentMethodNonce: paymentMethodNonce,
            allowNonScaCards: true
        };
        return WS.callServer('billing/savePaymentDetails', request);
    };

    this.getNumberOfDevices = (plan) => {
        if (plan == null) {
            return 5;
        }
        switch (plan.name) {
            case "Premium":
                return 10;
            case "Plus":
                return 7;
            case "Basic":
            default:
                return 5;
        }
    };

    this.getPlanNumOfCredits = (plan) => {
        if (plan == null) {
            return;
        }
        for (var i = 0; i < plan.packageList.length; i++) {
            var planPackage = plan.packageList[i];
            if (planPackage.creditsType === "EM_AUDIOBOOKS") {
                return planPackage.credits;
            }
        }
        return 0;
    };

    this.getPlanBillingCycleTimeUnits = (planObj) => {
        return planObj.billingCycleUnitType;
    };

    this.getAllPlans = async (callbackFunc) => {
        if (this.allPlanMap) {
            if (callbackFunc) callbackFunc(this.allPlanMap);
            return this.allPlanMap;
        }
        // TODO: including WINBACK in the next line is a dirty dirty hack to allow buying the plan,
        // in the real world we shouldn't be asking for winbacks all willy nilly
        const response = await this.getAvailablePlanListByFamilyList(
            ['MONTHLY', 'ANNUAL', 'TRIAL', 'BOOSTER', 'QUARTERLY', 'TAF_BONUS', 'WINBACK']);
        if (response.responseStatus !== "SUCCESS") {
            if (callbackFunc) callbackFunc(null);
            return null;
        }

        this.allPlanMap = {};
        for (var i = 0; i < response.planList.length; i++) {
            var plan = response.planList[i];
            if (!this.allPlanMap[plan.family]) {
                this.allPlanMap[plan.family] = [];
            }
            this.allPlanMap[plan.family].push(plan);
        }

        if (callbackFunc) callbackFunc(this.allPlanMap);
        return this.allPlanMap;
    };

    this.getCreditCardIconClass = (cardType) => {
        if (cardType == null) {
            return "noCard";
        }
        cardType = cardType.toLowerCase();
        switch (cardType) {
            case "visaelectron":
                return "visa";
            case "visa":
            case "discover":
            case "mastercard":
                return cardType;
            case "american express":
                return "amex";
            default:
                return "unsupportedCard";
        }
    };
}]);

